import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { FileText, Phone } from "lucide-react";
export default function FinalCtaStartFreeTrial() {
  return <section data-section-id="258628" id="final-cta-start-free-trial" className="bg-background bg-gradient-to-br from-accent to-background py-16 md:py-24">
      <div className="container mx-auto px-4 text-center">
        <h2 className="text-3xl md:text-4xl font-bold text-foreground mb-4 font-default">
          ¿Listo para transformar sus comunicaciones?
        </h2>
        <p className="text-muted-foreground mb-8 max-w-2xl mx-auto font-default text-lg">
          Prueba gratuita de 100%, sin necesidad de tarjeta de crédito. Descubra el poder de nuestra plataforma hoy mismo.
        </p>
        <div className="flex flex-col sm:flex-row justify-center items-center gap-4">
          <Button asChild className="bg-primary hover:bg-primary/90 text-primary-foreground rounded-lg h-12 px-8 text-base border-0 shadow-md transition-all">
            <Link to="/HomePage">
              <FileText className="mr-2 size-5" />
              Iniciar prueba gratuita
            </Link>
          </Button>
          <Button asChild variant="outline" className="bg-transparent border-secondary text-secondary hover:bg-secondary/10 rounded-lg h-12 px-8 text-base shadow-sm transition-all">
            <Link to="/OmnichannelPage">
              <Phone className="mr-2 size-5" />
              Programar Demo
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}